export const getPathToRedirect = (orderId: string, bankId: number) => {
  return `${window.location.origin}/redirect.html?orderId=${orderId}&bankId=${bankId}&hideIncrementModal=true&fromQRCode=true`;
};

export const getShortPathToRedirect = (orderId: string, bankId: number | string) => {
  return `/redirect.html?orderId=${orderId}&bankId=${bankId}`;
};
